import { Component, OnInit } from '@angular/core';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { OperationResult, TbAuthService } from '@tb/auth';
import { TrainingContact, TrainingTypes, TrainingType, Customer } from 'src/app/model/customer';
import { environment } from 'src/environments/environment';
import { ContactService } from 'src/app/core/services/contact.service';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { LoginService } from 'src/app/core/services/login.service';
import { ProxyService } from 'src/app/core/services/proxy.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { MacroAreaEnvironments } from 'src/app/model/macroarea-environments';
import { NewOperationResult } from 'src/app/core/services/operation-result-new';
import { CoursesService } from 'src/app/core/services/courses-service';

import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'ms-training-request',
    templateUrl: './training-request.component.html',
    styleUrls: ['./training-request.component.scss'],
})
export class TrainingRequestComponent implements OnInit {
    emailFormControl = new FormControl('', [Validators.required, Validators.email]);
    matcher = new MyErrorStateMatcher();

    public contact: TrainingContact = new TrainingContact();
    public myCustomers: Customer[] = [];
    public macroAreaEnvironments: MacroAreaEnvironments[] = [];
    public availableEnvironments: string[] = [];
    authorizationProperties: AuthorizationProperties;
    authorizationStored;

    public isLoading: boolean = false;

    constructor(
        public workflow: WorkFlowService,
        private variable: TranslatedVariables,
        private contactService: ContactService,
        private loginService: LoginService,
        private proxyService: ProxyService,
        private customerService: CustomerService,
        private authService: TbAuthService,
        private coursesService: CoursesService
    ) {}

    async ngOnInit() {
        this.isLoading = true;
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);

        // await this.customerService.getCustomerMasterData(
        //     this.authorizationProperties.accountEmail,
        //     this.authorizationProperties.accountName,
        //     ''
        // );

        let opResult: OperationResult = await this.proxyService.getEndUsersByReseller(
            this.authorizationProperties.accountName,
            this.customerService.companyInfo.CompanyCode,
            0
        );
        this.myCustomers = opResult.Content as Customer[];

        let macroAreaEnvironmentsRes: NewOperationResult<MacroAreaEnvironments[]> = await this.coursesService.getAllMacroAreaEnvironments();
        if (macroAreaEnvironmentsRes.Result) this.macroAreaEnvironments = macroAreaEnvironmentsRes.Content;

        this.initializeForm();
        this.isLoading = false;
    }

    initializeForm() {
        this.contact = new TrainingContact();
        this.contact.CompanyName = 'Azienda abc'; //Trovare ragione sociale
        this.contact.RequestFor = this.contact.CompanyName;
    }

    getTrainingTypes(): string[] {
        return Object.values(TrainingTypes);
    }

    setAvailableEnvironments(event: string[]) {
        let newElements = this.macroAreaEnvironments.filter((macroArea) => {
            return event.includes(macroArea.MacroArea);
        });
        let environmentsArray = newElements.map((macroArea) => macroArea.Environments);

        environmentsArray.forEach((environments) => {
            this.availableEnvironments = this.availableEnvironments.concat(environments);
        });
    }

    async SendRequest() {
        this.contact.CompanyName = 'RAGIONE SOCIALE LOGIN';
        try {
            let opResultSendMail: OperationResult = await this.contactService.sendmailcontactfortraining(
                this.contact,
                environment.auth.authToken
            );
            if (!opResultSendMail.Result) this.workflow.showSnackBar(this.variable.errorSendingMail);
            else this.workflow.showSnackBar(this.variable.operationSucceeded, this.variable.willBeContactedSoon);
        } catch (err) {
            this.workflow.showMessage(this.variable.errorTitle, err.message);
        }
    }
}
